export default __webpack_public_path__ + "f0fc8c798eac5636249c4ea287832422.svg";